import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import campaigns from './campaigns/campaigns.routes';
import canned from './canned/canned.routes';
import chatgpt from './chatgpt/chatgpt.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
// KANBAN0725
import kanban from './kanban/kanban.routes'; // ← AGREGAR ESTA LÍNEA
// KANBAN0725

import trackingTemplates from './trackingTemplates/trackingTemplates.routes'; // proyecto@tracking_templates
import knowledgeSources from './knowledgeSources/knowledgeSources.routes'; // @knowledge_sources
import whatsappTemplates from './whatsappTemplates/whatsappTemplates.routes'; // @waba_templates
import googleCalendar from './googleCalendar/googleCalendar.routes'; // proyecto@google_calendar

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: () => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return frontendURL('accounts/:accountId/settings/general');
        }
        return frontendURL('accounts/:accountId/settings/canned-response');
      },
    },
    ...account.routes,
    ...agent.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...campaigns.routes,
    ...canned.routes,
    ...chatgpt.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    // KANBAN0725
    ...kanban.routes, // ← AGREGAR ESTA LÍNEA
    // KANBAN0725
    ...trackingTemplates.routes, // proyecto@tracking_templates
    ...knowledgeSources.routes, // @knowledge_sources
    ...whatsappTemplates.routes, // @waba_templates
    ...googleCalendar.routes, // proyecto@google_calendar
  ],
};
